import { EDTFTypeTranslations } from './edtf-type-translations.entity';

export const EDTFTypePlaceholders: EDTFTypeTranslations = {
    DATE_COMPLETE: '1985-04-12',
    DATE_PRECISION_YEAR_AND_MONTH: '1985-04',
    DATE_PRECISION_YEAR: '1985',
    DATETIME_COMPLETE: '1985-04-12T23:20:30',
    DATETIME_COMPLETE_UTC: '1985-04-12T23:20:30Z',
    DATETIME_COMPLETE_SHIFT: '1985-04-12T23:20:30+04:30',
    TIME_INTERVAL: '1985-04/1986',
    LETTER_PREFIXED_YEAR: 'Y170000002',
    SEASONS: '1985-21',
    DATE_QUALIFICATION_UNCERTAIN: '1985-04?',
    DATE_QUALIFICATION_APPROXIMATE: '1985-04~',
    DATE_QUALIFICATION_UNCERTAIN_APPROXIMATE: '1985-04%',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_DECADE: '198X',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_CENTURY: '19XX',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_MONTH: '1985-XX',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_DAY_IN_YEAR: '1985-XX-XX',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_DAY_IN_MONTH: '1985-04-XX',
    EXTENDED_INTERVAL_OPEN_END: '1985-04-12/..',
    EXTENDED_INTERVAL_OPEN_BEGIN: '../1985-04-12',
    EXTENDED_INTERVAL_UNKNOWN_END: '1985-04-12/',
    EXTENDED_INTERVAL_UNKNOWN_BEGIN: '/1985-04-12',
    EXTENDED_INTERVAL: '1985-04%/1986',
    NEGATIVE_CALENDER_YEAR: '-0750',
    COMPLETELY_UNSPECIFIED: 'XXXX-XX-XX'
};
